export const HMapPanels = {
  HMapInstruction: 'HMapInstruction',
  HMapDisplay: 'HMapDisplay',
  HMapDetailsNew: 'HMapDetailsNew',
  HMapDetailsEdit: 'HMapDetailsEdit',
  HMapDetailsReadOnly: 'HMapDetailsReadOnly'
}
